import { render } from "./TheReleaseStationStalls.vue?vue&type=template&id=32123d4e"
import script from "./TheReleaseStationStalls.vue?vue&type=script&lang=js"
export * from "./TheReleaseStationStalls.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__